import { type FC, useEffect } from 'react';
import { motion, useAnimate } from 'framer-motion';

import css from './styles.module.scss';

interface TapEffectProps {
  id: number | string;
  value: number;
  top: number;
  left: number;
  onAnimationEnd: (id: string | number) => void;
}

const TapEffect: FC<TapEffectProps> = ({
  id,
  value,
  top,
  left,
  onAnimationEnd,
}) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const onAnimate = async (): Promise<void> => {
      await animate(
        scope.current,
        { x: '-50%', y: '-250%' },
        { ease: 'linear', duration: 0.5 },
      );
      await animate(
        scope.current,
        { scale: 0.5, opacity: 0 },
        { ease: 'linear', duration: 0.2 },
      );
      onAnimationEnd(id);
    };

    onAnimate();
  }, []);

  return (
    <motion.div
      initial={{ x: '-50%', y: '-50%' }}
      ref={scope}
      style={{
        top,
        left: `calc(${left}px - var(--desktop-container-offset-left))`,
      }}
      className={css.tapEffect}
    >
      +{value}
    </motion.div>
  );
};

export { TapEffect };
